module.exports = "/images/vendor/flag-icon-css/flags/1x1/pw.svg?78aaead281d584ac98bb1948f12eb776";